var React = require('react');

function LineArrow (props) {
    return React.createElement("svg",props,[React.createElement("polyline",{"points":"62.53 24.53 87.94 49.94 62.53 75.36","style":{"fill":"none","stroke":"#ff6e00","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"6px"},"key":0}),React.createElement("line",{"x1":"12.41","y1":"49.94","x2":"87.94","y2":"49.94","style":{"fill":"none","stroke":"#ff6e00","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"6px"},"key":1})]);
}

LineArrow.defaultProps = {"id":"Ebene_1","data-name":"Ebene 1","viewBox":"0 0 100 100"};

module.exports = LineArrow;

LineArrow.default = LineArrow;
